import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../actions/account.action";
import { useSelector, useDispatch } from "react-redux";
import {
  getSessions,
  getMaterials,
  closeRequestModal,
  closeAssessmentsModal,
  closeDisclaimerModal,
  openDisclaimerModal as openDisclaimerModalAction,
  checkSmsStatus,
  setSmsData,
  resetSecondsLeft,
} from "../actions/portal.action";
import localizationService from "../services/localization-service";

import navLogo from "../assets/img/EHN-Online-Site.png";
import ActivityDetector from "activity-detector";
import config from "../config";
import { features } from "../config/features";
import storageService from "../services/storage-service";
import {
  postTimeZone,
  changeUserLang,
  updateResponseStatus,
} from "../actions/account.action";
import notification from "../services/notification-service";
import { showSmsError } from "../utils/sms-helpers.js";
import SmsState from "../models/SmsState";
import SmsReminderModal from "../components/modals/modal-sms-reminder";
import SmsNoThanksModal from "../components/modals/modal-sms-no-thanks";
import VerificationPromptModal from "../components/modals/modal-verification-prompt";
import UserMenu from "../components/user-menu";
import { AuthContext } from "../framework/auth";
import $ from "jquery";

const MasterPage = (props) => {
  const navigate = useNavigate();
  const [currentTimeZone, setCurrentTimeZone] = useState(null);
  const [timeZoneCheck, setTimeZoneCheck] = useState(false);
  const dispatch = useDispatch();
  const selectedlang = useSelector((state) => state.account.lang);
  const loggedUser = useSelector((state) => state.account.loggedUser);
  const smsData = useSelector((state) => state.portal.smsData);
  const location = useLocation();
  const [hasRequest, setHasRequest] = useState(false);
  const [hasAssessments, setHasAssessments] = useState(false);
  const [hasDisclaimer, setHasDisclaimer] = useState(false);
  const timeZones = useSelector((state) => state.account.timeZones);
  const [timeZoneModal, setTimeZoneModal] = useState(false);
  const [timeZoneSelectedId, setTimeZoneSelectedId] = useState(null);
  const assessments = useSelector((state) => state.portal.assessments) || [];
  const [openSmsReminderModal, setOpenSmsReminderModal] = useState(null); // It should be set to true when client logs in and hasn't clicked "No thanks" before and if client clicked "Later" or "No thanks" after logging and then or later clicks Text Messsages tab
  const [openSmsNoThanksModal, setSmsNoThanksModal] = useState(false);
  const [showIdentityVerificationModal, setShowIdentityVerificationModal] =
    useState(
      () => sessionStorage.getItem("identityVerificationShown") !== "true",
    );
  const [open, setOpen] = useState(false);
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const dropdownRef = useRef(null);
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);
  const [smsStatusFetched, setSmsStatusFetched] = useState(false);

  const noThanksClickedOnTextMessages = useRef(false); // Used to track if user clicked "No thanks" on Text Messages modal in order not to open modal-session-reminder again

  // Scenario: Client logged in. Modal for selecting group is opened. Client clicks Choose now. We don't close the modal permanently. We close it when client navigate to some other page after that.
  const url = location.pathname;
  const pageFromUrl = url.split("/").filter(Boolean);

  const openRequestModal = useSelector(
    (state) => state.portal.openRequestModal,
  );

  const openAssessmentModal = useSelector(
    (state) => state.portal.openAssessmentModal,
  );

  const openTextMessagesModal = useSelector(
    (state) => state.portal.openTextMessagesModal,
  );

  const openDisclaimerModal = useSelector(
    (state) => state.portal.openDisclaimerModal,
  );

  const openVerificationModal = useSelector(
    (state) => state.portal.openVerificationModal,
  );

  const verificationStatus = useSelector(
    (state) => state.account.loggedUser?.VerificationStatus ?? 0,
  );
  const showVerificationNav =
    features.identityVerification &&
    verificationStatus !== 3 &&
    verificationStatus !== 4;

  const { isAuth } = useContext(AuthContext);

  const secondsLeft = useSelector((state) => state.portal.secondsLeft);

  const [userName, setUserName] = useState("");
  const [showTimeZoneValidationMsg, setshowTimeZoneValidationMsg] =
    useState(false);

  useEffect(() => {
    var ctz = storageService.getStorageItem(config.TIMEZONE);
    if (ctz != null) {
      setCurrentTimeZone(ctz);
      setTimeZoneCheck(false);

      if (openRequestModal && pageFromUrl[0] != "programs") {
        setHasRequest(true);
      }

      if (openAssessmentModal && pageFromUrl[0] != "assessments") {
        setHasAssessments(true);
      }

      // Check both Redux state and localStorage for disclaimer
      const disclaimerAccepted = localStorage.getItem(
        config.DISCLAIMER_ACCEPTED,
      );
      if (disclaimerAccepted !== "true" || openDisclaimerModal) {
        setHasDisclaimer(true);
      }
    } else {
      setTimeZoneCheck(true);
    }
  }, [currentTimeZone, openDisclaimerModal]);

  useEffect(() => {
    setUserName(storageService.getStorageItem(config.USERNAME));

    let body = document.querySelector("body");

    if (window.innerWidth < 500) {
      if (
        location.pathname === "/textMessages" ||
        location.pathname === "/termsOfUse" ||
        location.pathname === "/login"
      ) {
        body.classList.remove("bg-gray-50");
        body.classList.add("white-background");
      } else {
        body.classList.remove("white-background");
      }

      setIsDesktopResolution(false);
    }

    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenUserMenu(false);
      }
    }

    function handleEsc(event) {
      if (event.key === "Escape") {
        setOpenUserMenu(false);
      }
    }

    function handleScroll() {
      setOpenUserMenu(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  // 1. Fetch SMS status on first mount
  useEffect(() => {
    dispatch(
      checkSmsStatus(Number(storageService.getStorageItem(config.USER_ID))),
    )
      .then(() => setSmsStatusFetched(true))
      .catch(() => setSmsStatusFetched(true));
  }, [dispatch]);

  // 2. Respond to updated SMS data
  useEffect(() => {
    if (smsData.smsState === undefined) return;
    if (!smsStatusFetched) return;

    if (url !== "/textMessages") {
      storageService.setStorageItem(config.JUST_UNSUBSCRIBED, false);
    }

    let smsReminder = false;

    let todayDate = new Date();
    let numOfWeeksFromLastSMSReminder = null;

    // todayDate.setHours(0, 0, 0, 0);

    if (smsData.actionDate !== null) {
      const laterActionDate = new Date(smsData.actionDate + "Z");

      numOfWeeksFromLastSMSReminder =
        (todayDate - laterActionDate) / (1000 * 60 * 60 * 24 * 7);
    }

    if (
      (smsData.smsState === SmsState.notProcessed &&
        url === "/" &&
        !storageService.getStorageItem(config.SMS_CLICKED_YES)) ||
      (smsData.smsState === SmsState.later &&
        numOfWeeksFromLastSMSReminder >= 2) ||
      (smsData.smsState === SmsState.unsubscribed &&
        url === "/textMessages" &&
        storageService.getStorageItem(config.JUST_UNSUBSCRIBED) === "false") ||
      (smsData.smsState === SmsState.canceled &&
        smsData.cellPhoneNumber === null &&
        url === "/textMessages" &&
        !noThanksClickedOnTextMessages.current)
    ) {
      smsReminder = true;
    } else {
      smsReminder = false;
    }

    setOpenSmsReminderModal(smsReminder);
  }, [smsData, url, smsStatusFetched]);

  // 3. Check if disclaimer is accepted on mount
  useEffect(() => {
    const disclaimerAccepted = localStorage.getItem(config.DISCLAIMER_ACCEPTED);
    if (isAuth && disclaimerAccepted !== "true") {
      setHasDisclaimer(true);
      dispatch(openDisclaimerModalAction());
    }
  }, [dispatch]);

  const [currentRoute, setCurrentRoute] = useState("/");

  const sessionTimeoutRef = useRef(null);

  const autoLogoutEnabled = Boolean(config.AUTO_LOGOUT_ENABLED);

  const onLogout = useCallback(() => {
    if (
      smsData.smsState === SmsState.processing &&
      (secondsLeft === 0 || secondsLeft === null)
    ) {
      const request = {
        userId: Number(storageService.getStorageItem(config.USER_ID)),
        cellPhoneNumber: null,
        smsState: SmsState.notProcessed, // when user logs out, before confirming verification code, we set the sms state to not processed, so that user has to repeat the wntire proces for submition
      };
      dispatch(setSmsData(request)).catch(() => {
        showSmsError(selectedlang);
      });
    }

    // if seconds left is 0, remove phone number from local storage, so when user logs in again, the phone number input is empty
    if (secondsLeft === 0 || secondsLeft === null) {
      localStorage.removeItem(
        `PhoneNumber_${Number(storageService.getStorageItem(config.USER_ID))}`,
      );
      dispatch(resetSecondsLeft());
    }

    dispatch(logoutUser());
    sessionStorage.clear();
    localStorage.removeItem(config.DISCLAIMER_ACCEPTED);
    localStorage.removeItem(config.STAY_LOGGED_IN_UNTIL);
    clearTimeout(sessionTimeoutRef.current);
    navigate("/login");
  }, [dispatch, navigate, smsData, selectedlang, secondsLeft]);

  const getAutoLogoutDelay = useCallback(() => {
    const stayLoggedInUntil = localStorage.getItem(config.STAY_LOGGED_IN_UNTIL);

    if (stayLoggedInUntil) {
      const expirationTime = parseInt(stayLoggedInUntil, 10);
      const now = Date.now();

      if (expirationTime > now) {
        const remainingMs = expirationTime - now;
        const extendedHoursMs = config.STAY_LOGGED_IN_HOURS * 60 * 60 * 1000;
        return Math.min(remainingMs, extendedHoursMs);
      } else {
        localStorage.removeItem(config.STAY_LOGGED_IN_UNTIL);
        localStorage.removeItem(config.TOKEN);
        return 0;
      }
    }

    return Math.max(Number(config.AUTO_LOGOUT_MINUTES) || 0, 1) * 60 * 1000;
  }, []);

  useEffect(() => {
    if (!autoLogoutEnabled) {
      clearTimeout(sessionTimeoutRef.current);
      return;
    }

    const resetTimer = () => {
      clearTimeout(sessionTimeoutRef.current);
      const currentDelay = getAutoLogoutDelay();
      if (currentDelay <= 0) {
        onLogout();
        return;
      }
      sessionTimeoutRef.current = window.setTimeout(onLogout, currentDelay);
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "touchstart",
      "scroll",
    ];
    events.forEach((evt) => window.addEventListener(evt, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(sessionTimeoutRef.current);
      events.forEach((evt) => window.removeEventListener(evt, resetTimer));
    };
  }, [autoLogoutEnabled, getAutoLogoutDelay, onLogout]);

  //const autoLoggout = useIdle({ timeToIdle: 1 }); //initialize the idle timer

  useEffect(() => {
    let body = window.document.body;

    $('[data-toggle="offcanvas"]').on("click", function () {
      $(".offcanvas-collapse").toggleClass("open");
      $(".navbar-toggler").toggleClass("collapsed");
    });
    $('[data-toggle="offcanvas"]').on("click", function () {
      $("body").toggleClass("opened-menu");
    });

    body.classList.remove("login-page");

    setCurrentRoute(location.pathname);
  }, [location.pathname]);

  const closeModal = (route) => {
    setHasRequest(false);
    // dispatch(closeRequestModal());
    if (route.includes("programs")) {
      setHasAssessments(false);
      navigate(route);
    } else {
      dispatch(closeRequestModal());
    }
  };

  const closeAssessmentModal = (route) => {
    setHasAssessments(false);
    dispatch(closeAssessmentsModal());
    if (route.includes("assessments")) {
      navigate(route);
    }
  };

  const closeTextMessagesModal = (route, doNotSubscribe) => {
    let request = {
      userId: Number(storageService.getStorageItem(config.USER_ID)),
      cellPhoneNumber: null,
    };

    setOpenSmsReminderModal(false);

    if (route.includes("textMessages")) {
      setOpenSmsReminderModal(false);
      storageService.setStorageItem(config.SMS_CLICKED_YES, true);
      navigate(route);
    } else if (doNotSubscribe) {
      // No thanks option
      if (url === "/textMessages") {
        noThanksClickedOnTextMessages.current = true; // ← DODATI OVO
      }
      request.smsState = SmsState.canceled;
      dispatch(setSmsData(request))
        .then(function (response) {
          setSmsNoThanksModal(true);
        })
        .catch(function (res) {
          showSmsError(selectedlang);
        });
    } else {
      // Later option
      request.smsState = SmsState.later;
      dispatch(setSmsData(request))
        .then(function (response) {})
        .catch(function (res) {
          showSmsError(selectedlang);
        });
    }
  };

  const closeNotToSubscribeModal = () => {
    setSmsNoThanksModal(false);
  };

  const openTimeZoneModal = () => {
    setTimeZoneModal(true);
    setshowTimeZoneValidationMsg(false);
  };

  const closeTimeZoneModal = () => {
    setTimeZoneModal(false);
  };

  const changeDropDown = (timeZoneId) => {
    setTimeZoneSelectedId(timeZoneId);
    setshowTimeZoneValidationMsg(false);
  };

  const clickUpdateTimeZone = () => {
    if (timeZoneSelectedId == null) {
      setshowTimeZoneValidationMsg(true);
    } else {
      dispatch(postTimeZone(timeZoneSelectedId))
        .then(function (res) {
          setCurrentTimeZone(timeZoneSelectedId);
          notification.success(
            localizationService.getLocalizationValue(
              "timezoneUpdatedSuccess",
              selectedlang,
            ),
          );
          if (!openRequestModal) {
            window.location.reload();
          }
        })
        .catch(function (res) {});
    }
  };

  const changeLang = (lang) => {
    dispatch(changeUserLang(lang));
    setOpenUserMenu(false);

    if (currentRoute == "/") {
      dispatch(getSessions(lang));
    }

    if (currentRoute == "/materials") {
      dispatch(getMaterials(lang));
    }
  };

  // Scenario: Client loggs in. Modal for selecting group is opened. Client clicks Choose now. We don't close the modal permanently.
  // We close it permanently when client navigate to some other page after that.
  const changeRoute = (currentRoute, e) => {
    const disclaimerAccepted = localStorage.getItem(config.DISCLAIMER_ACCEPTED);
    if (disclaimerAccepted !== "true") {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      return false;
    }

    if (currentRoute != "programs" && currentRoute != "/") {
      dispatch(closeRequestModal());
    }
    return true;
  };

  // Handler to block navigation if disclaimer is not accepted
  const handleLinkClick = (e, route) => {
    const disclaimerAccepted = localStorage.getItem(config.DISCLAIMER_ACCEPTED);
    if (disclaimerAccepted !== "true") {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    changeRoute(route);
    return true;
  };

  return (
    <React.Fragment>
      <nav className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <Link to="/" className="flex-shrink-0 flex items-center">
                <img className="h-9 w-auto" src={navLogo} alt="Logo" />
              </Link>
              <div className="hidden lg:ml-6 lg:flex lg:space-x-8">
                <Link
                  to="/"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                    currentRoute === "/"
                      ? "border-[#9aa82d] text-gray-900"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                  onClick={() => changeRoute("/")}
                >
                  {localizationService.getLocalizationValue(
                    "sessionHeading",
                    selectedlang,
                  )}
                </Link>
                <Link
                  to="/materials"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                    currentRoute === "/materials"
                      ? "border-[#9aa82d] text-gray-900"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                  onClick={() => changeRoute("/materials")}
                >
                  {localizationService.getLocalizationValue(
                    "materialsTitle",
                    selectedlang,
                  )}
                </Link>
                <Link
                  to="/programs"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                    currentRoute === "/programs"
                      ? "border-[#9aa82d] text-gray-900"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                  onClick={() => changeRoute("/programs")}
                >
                  {localizationService.getLocalizationValue(
                    "programsTitle",
                    selectedlang,
                  )}
                </Link>
                <Link
                  to="/assessments"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                    currentRoute === "/assessments"
                      ? "border-[#9aa82d] text-gray-900"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                  onClick={() => changeRoute("/assessments")}
                >
                  {localizationService.getLocalizationValue(
                    "assessmentsTitle",
                    selectedlang,
                  )}
                  {/* Conditionally show the red dot inside the button */}
                  {/* {assessments && assessments.length > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#ee3838",
                        borderRadius: "50%",
                      }}
                    ></span>
                  )} */}
                </Link>
                <Link
                  to="/textMessages"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                    currentRoute === "/textMessages"
                      ? "border-[#9aa82d] text-gray-900"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                  onClick={() => changeRoute("/textMessages")}
                >
                  {localizationService.getLocalizationValue(
                    "textMessages",
                    selectedlang,
                  )}
                </Link>
                {showVerificationNav && (
                  <Link
                    to="/verification"
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-md font-medium menu-link ${
                      currentRoute === "/verification"
                        ? "border-[#9aa82d] text-gray-900"
                        : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                    }`}
                    onClick={(e) => handleLinkClick(e, "/verification")}
                  >
                    Verification
                  </Link>
                )}
              </div>
            </div>

            {/* User Menu */}
            {/*Show this only  to logged in users*/}
            {isAuth && (
              <div className="hidden lg:ml-6 lg:flex lg:items-center lg:space-x-4">
                <div
                  ref={dropdownRef}
                  className="relative inline-block text-center"
                >
                  {/* Trigger Button */}
                  <button
                    onClick={() => setOpenUserMenu(!openUserMenu)}
                    className="flex items-center justify-center gap-2 w-40 px-4 py-2 text-[#9aa82d]"
                  >
                    <i className="fal fa-user"></i>
                    <span className="mt-[3px]">{userName}</span>
                  </button>

                  {/* Dropdown */}
                  <UserMenu
                    isOpen={openUserMenu}
                    onLanguageChange={(lang) => changeLang(lang)}
                    onTimeZoneChange={() => openTimeZoneModal()}
                    currentTimeZone={currentTimeZone}
                    timeZones={timeZones}
                    onLogout={() => onLogout()}
                  />
                </div>
              </div>
            )}

            {/* Mobile menu button */}
            <div className="flex items-center lg:hidden">
              <button
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
                onClick={() => {
                  $(".offcanvas-collapse").toggleClass("open");
                  $(".navbar-toggler").toggleClass("collapsed");
                  $("body").toggleClass("opened-menu");
                }}
              >
                <span className="sr-only">Open main menu</span>
                <div className="w-6 h-6 flex flex-col justify-center space-y-2">
                  <span className="block w-full h-0.5 bg-current transform transition-transform"></span>
                  <span className="block w-full h-0.5 bg-current transform transition-transform"></span>
                  <span className="block w-full h-0.5 bg-current transform transition-transform"></span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div className="lg:hidden offcanvas-collapse bg-white shadow-lg">
          <div className="pt-2 pb-3 space-y-1">
            <div
              style={{ marginLeft: "4px" }}
              className="m- border-b border-gray-100 block pl-4 pr-4 py-3 text-base font-medium"
            >
              <div className="flex justify-between">
                <span className="text-gray-800 font-medium">{userName}</span>
                <div className="flex justify-end space-x-2 text-sm">
                  <button
                    type="button"
                    onClick={() => changeLang("en-CA")}
                    className={`${
                      selectedlang === "en-CA"
                        ? "text-[#9aa82d] font-bold"
                        : "text-gray-400 hover:text-gray-600"
                    }`}
                  >
                    EN
                  </button>
                  <span className="text-gray-300">|</span>
                  <button
                    type="button"
                    onClick={() => changeLang("fr-CA")}
                    className={`${
                      selectedlang === "fr-CA"
                        ? "text-[#9aa82d] font-bold"
                        : "text-gray-400 hover:text-gray-600"
                    }`}
                  >
                    FR
                  </button>
                </div>
              </div>
            </div>
            <Link
              to="/"
              className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                currentRoute === "/"
                  ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                  : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
              }`}
            >
              {localizationService.getLocalizationValue(
                "sessionHeading",
                selectedlang,
              )}
            </Link>
            <Link
              to="/materials"
              className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                currentRoute === "/materials"
                  ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                  : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
              }`}
            >
              {localizationService.getLocalizationValue(
                "materialsTitle",
                selectedlang,
              )}
            </Link>
            <Link
              to="/programs"
              className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                currentRoute === "/programs"
                  ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                  : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
              }`}
            >
              {localizationService.getLocalizationValue(
                "programsTitle",
                selectedlang,
              )}
            </Link>
            <Link
              to="/assessments"
              className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                currentRoute === "/assessments"
                  ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                  : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
              }`}
            >
              {localizationService.getLocalizationValue(
                "assessmentsTitle",
                selectedlang,
              )}
            </Link>
            <Link
              to="/textMessages"
              className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                currentRoute === "/textMessages"
                  ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                  : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
              }`}
            >
              {localizationService.getLocalizationValue(
                "textMessages",
                selectedlang,
              )}
            </Link>
            {showVerificationNav && (
              <Link
                to="/verification"
                className={`block pl-4 pr-4 py-3 text-base font-medium transition-colors duration-200 ${
                  currentRoute === "/verification"
                    ? "bg-[#f5f7eb] border-l-4 border-[#9aa82d] text-[#9aa82d]"
                    : "border-l-4 border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#9aa82d] hover:text-[#9aa82d]"
                }`}
              >
                Verification
              </Link>
            )}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-100">
            <div className="flex flex-col space-y-3 px-4">
              {currentRoute !== "/" && (
                <button
                  onClick={() => openTimeZoneModal()}
                  className="w-full inline-flex items-center justify-center px-4 py-2 border border-[#9aa82d] text-sm font-medium rounded-md text-[#9aa82d] bg-white hover:bg-[#f5f7eb] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9aa82d] transition-colors duration-200"
                >
                  <i className="fal fa-clock mr-2"></i>
                  {currentTimeZone
                    ? timeZones.find((x) => x.id == currentTimeZone).name
                    : localizationService.getLocalizationValue(
                        "setTimeZone",
                        selectedlang,
                      )}
                </button>
              )}
              <button
                onClick={() => onLogout()}
                className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9aa82d] transition-colors duration-200"
              >
                <i className="fal fa-sign-out mr-2"></i>
                {localizationService.getLocalizationValue(
                  "sideMenuLogoutTitle",
                  selectedlang,
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className={`${isDesktopResolution ? "pb-8" : ""}`}>
        <div
          className={`max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 ${
            currentRoute === "/programs" && !isDesktopResolution ? "pt-0" : ""
          }`}
        >
          {props.children}
        </div>
      </main>

      {/* Time Zone Modal */}
      {timeZoneModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div
              className="px-6 py-4 border-b border-gray-200"
              style={{ position: "relative" }}
            >
              <h3 className="text-lg font-medium text-gray-900">
                {localizationService.getLocalizationValue(
                  "selectTimeZone",
                  selectedlang,
                )}
              </h3>
              <i
                className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
                onClick={closeTimeZoneModal}
              ></i>
            </div>
            <div className="px-6 py-4">
              <p className="text-sm text-gray-500 mb-4">
                {currentTimeZone !== null
                  ? localizationService.getLocalizationValue(
                      "currentTimeZone",
                      selectedlang,
                    ) +
                    ": " +
                    timeZones.find((x) => x.id == currentTimeZone).name
                  : localizationService.getLocalizationValue(
                      "timeZoneNotSet",
                      selectedlang,
                    )}
              </p>
              <div className="relative">
                <select
                  className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
                  value={timeZoneSelectedId || ""}
                  onChange={(e) => changeDropDown(e.target.value)}
                >
                  <option value="">
                    {localizationService.getLocalizationValue(
                      "selectTimeZone",
                      selectedlang,
                    )}
                  </option>
                  {timeZones.map((tz) => (
                    <option key={tz.id} value={tz.id}>
                      {tz.name}
                    </option>
                  ))}
                </select>
              </div>
              {showTimeZoneValidationMsg && (
                <p className="mt-2 text-sm text-red-600">
                  {localizationService.getLocalizationValue(
                    "timeZoneValidationMsg",
                    selectedlang,
                  )}
                </p>
              )}
            </div>
            <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end space-x-3">
              <button
                onClick={clickUpdateTimeZone}
                className="inline-flex w-[50%] justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                {localizationService.getLocalizationValue(
                  "updateTimeZone",
                  selectedlang,
                )}
              </button>
              <button
                onClick={closeTimeZoneModal}
                className="inline-flex w-[50%] justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:!bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
              >
                {localizationService.getLocalizationValue(
                  "close",
                  selectedlang,
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {hasAssessments &&
        !openRequestModal &&
        !openDisclaimerModal &&
        currentRoute !== "/textMessages" && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
              <div
                className="px-6 py-4 border-b border-gray-200"
                style={{
                  position: "relative",
                }}
              >
                <h3 className="text-lg font-medium text-gray-900">
                  {localizationService.getLocalizationValue(
                    "assessmentNotificationTitle",
                    selectedlang,
                  )}
                </h3>
                <i
                  className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
                  onClick={() => closeAssessmentModal("/")}
                ></i>
              </div>
              <div className="px-6 py-4">
                <p className="text-sm text-gray-500">
                  {localizationService.getLocalizationValue(
                    "assessmentNotification",
                    selectedlang,
                  )}
                </p>
              </div>
              <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
                <button
                  onClick={() => closeAssessmentModal("/assessments")}
                  className="inline-flex items-center w-[50%] justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  style={{
                    paddingTop: "20px !important",
                    paddingBottom: "20px !important",
                  }}
                >
                  {localizationService.getLocalizationValue(
                    "chooseAssessmentOption",
                    selectedlang,
                  )}
                </button>
                <button
                  onClick={() => closeAssessmentModal("/")}
                  className="inline-flex items-center w-[50%] justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:!bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
                >
                  {localizationService.getLocalizationValue(
                    "laterOption",
                    selectedlang,
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Request Modal */}
      {hasRequest &&
        openSmsReminderModal !== null &&
        !openSmsReminderModal &&
        !openSmsNoThanksModal &&
        !openDisclaimerModal &&
        currentRoute !== "/textMessages" && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
              <div
                className="px-6 py-4 border-b border-gray-200"
                style={{ position: "relative" }}
              >
                <h3 className="text-lg font-medium text-gray-900">
                  {localizationService.getLocalizationValue(
                    "programIntroTitle",
                    selectedlang,
                  )}
                </h3>
                <i
                  className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
                  onClick={() => closeModal("/")}
                ></i>
              </div>
              <div className="px-6 py-4">
                <p className="text-sm text-gray-500">
                  {localizationService.getLocalizationValue(
                    "programIntroText1",
                    selectedlang,
                  )}
                </p>
              </div>
              <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
                <button
                  onClick={() => closeModal("/programs")}
                  className="inline-flex items-center w-[50%] justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                >
                  {localizationService.getLocalizationValue(
                    "chooseOption",
                    selectedlang,
                  )}
                </button>
                <button
                  onClick={() => closeModal("/")}
                  className="inline-flex items-center w-[50%] justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:!bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
                >
                  {localizationService.getLocalizationValue(
                    "laterOption",
                    selectedlang,
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Text Message Reminders modal */}
      <SmsReminderModal
        isOpen={openSmsReminderModal}
        onClose={(route, unsubscribe) =>
          closeTextMessagesModal(route, unsubscribe)
        }
      />

      {/* Chosen not to subscribe (No thanks) to text messages modal */}
      <SmsNoThanksModal
        isOpen={openSmsNoThanksModal}
        onClose={() => closeNotToSubscribeModal()}
      />

      {/* Identity Verification modal */}
      <VerificationPromptModal
        isOpen={features.identityVerification && openVerificationModal}
      />

      {/* Disclaimer Modal */}
      {hasDisclaimer && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full">
            <div
              className="px-6 py-4 border-b border-gray-200"
              style={{ position: "relative" }}
            >
              <h3 className="text-lg font-medium text-gray-900">
                Welcome to Guardian Family Connect
              </h3>
            </div>
            <div className="px-6 py-4 max-h-[70vh] overflow-y-auto">
              <p className="text-sm text-gray-500">
                The Guardian Family Connect program offers a welcoming,
                non-clinical space for family members of our Guardian clients.
                It's a place to share experiences, ask questions, and connect
                with others who understand the journey. The group focuses on
                mutual support and helping families feel informed and supported
                as their loved ones continue their recovery.
              </p>
              <p className="text-sm text-gray-500 mt-3">
                To help create a safe, respectful, and productive space for
                everyone, please review the following guidelines:
              </p>
              <ul className="text-sm text-gray-500 mt-3 list-disc pl-5 space-y-2">
                <li>
                  This group is not a clinical service. Facilitators will guide
                  discussion but cannot offer therapy, crisis counselling, or
                  individualized clinical support.
                </li>
                <li>
                  Confidentiality - What is shared in the group stays in the
                  group. Please protect the privacy of all participants.
                </li>
                <li>
                  Respect & Non-Judgment - We honor each person's journey.
                  Please speak from your own experience and listen with
                  compassion.
                </li>
                <li>
                  Technology Etiquette - Please join from a private space, keep
                  your camera on, and minimize distractions. Participants are
                  encouraged to join from a laptop or desktop.
                </li>
              </ul>
              <p className="text-sm text-gray-500 mt-3">
                If you choose to withdraw from the group, please email{" "}
                <a
                  href="mailto:ehn_ccc@ehncanada.com"
                  className="text-[#9aa82d] hover:underline"
                >
                  ehn_ccc@ehncanada.com
                </a>{" "}
                to stop receiving invitations.
              </p>
              <p className="text-sm text-gray-500 mt-3">
                If you are experiencing distress, mental health challenges,
                thoughts of self-harm or suicide, or have immediate concerns for
                your safety, it is strongly recommended that you seek assistance
                immediately. For emergencies or situations involving imminent
                risk to life, call{" "}
                <span className="font-medium text-gray-700">911</span>. For an
                urgent mental health crisis that is not life-threatening, dial{" "}
                <span className="font-medium text-gray-700">988</span> or visit
                your nearest emergency department. You may also consider
                reaching out to a trusted individual or qualified mental health
                professional for support. Professional help is available to
                provide guidance, resources, and strategies to assist you in
                working toward healing and recovery.
              </p>
              <p className="text-sm font-medium mt-4 text-center">
                You must accept to continue.
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
              <button
                onClick={() => {
                  dispatch(updateResponseStatus(1))
                    .then(() => {
                      localStorage.setItem(config.DISCLAIMER_ACCEPTED, "true");
                      setHasDisclaimer(false);
                      dispatch(closeDisclaimerModal());
                    })
                    .catch(() => {
                      notification.error(
                        "An error occurred while accepting the disclaimer. Please try again.",
                      );
                    });
                }}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Identity Verification Modal */}
      {showIdentityVerificationModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-medium text-gray-900">
                {localizationService.getLocalizationValue(
                  "identityVerificationModalTitle",
                  selectedlang,
                )}
              </h3>
            </div>
            <div className="px-6 py-4">
              <p className="text-sm text-gray-500">
                {localizationService.getLocalizationValue(
                  "identityVerificationModalStartingWord",
                  selectedlang,
                )}
                <strong className="font-bold text-gray-700">
                  {localizationService.getLocalizationValue(
                    "identityVerificationModalStartDate",
                    selectedlang,
                  )}
                </strong>
                {localizationService.getLocalizationValue(
                  "identityVerificationModalToSupport",
                  selectedlang,
                )}
              </p>
              <p className="text-sm text-gray-500 mt-3">
                {localizationService.getLocalizationValue(
                  "identityVerificationModalYouWillBePrompted",
                  selectedlang,
                )}
                <strong className="font-bold text-gray-700">
                  {localizationService.getLocalizationValue(
                    "identityVerificationModalFirstName",
                    selectedlang,
                  )}
                </strong>
                <strong className="font-bold text-gray-700">
                  {localizationService.getLocalizationValue(
                    "identityVerificationModalLastName",
                    selectedlang,
                  )}
                </strong>
                {localizationService.getLocalizationValue(
                  "identityVerificationModalAnd",
                  selectedlang,
                )}
                <strong className="font-bold text-gray-700">
                  {localizationService.getLocalizationValue(
                    "identityVerificationModalDateOfBirth",
                    selectedlang,
                  )}
                </strong>
                {localizationService.getLocalizationValue(
                  "identityVerificationModalPartThree",
                  selectedlang,
                )}
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center">
              <button
                onClick={() => {
                  sessionStorage.setItem("identityVerificationShown", "true");
                  setShowIdentityVerificationModal(false);
                }}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                {localizationService.getLocalizationValue(
                  "identityVerificationModalContinue",
                  selectedlang,
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MasterPage;
